export default class Response {
  static STATUS_OK = 200;
  static TOKEN_EXPIRED = 202;
  static INVITE_SENT = 219;
  static EXIST_NAME = 220;
}
